'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import MaterialIconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';
import { getFuelSize } from '../types/general';
import { excludeComponentProps } from '../utils/excludeComponentProps';
const StyledButton = styled(MaterialIconButton, {
    ...excludeComponentProps('size', 'variant', 'outlined')
})(({ theme, size: currentSize, outlined }) => {
    const size = getFuelSize(currentSize);
    return {
        transition: 'unset',
        borderRadius: `${theme.tokens.FuelBorderRadiusMd}`,
        border: '1px solid transparent',
        display: 'inline-flex',
        alignItems: 'center',
        ...size === 'small' && {
            height: '2rem',
            width: '2rem',
            padding: '0.1875rem'
        },
        ...size === 'medium' && {
            height: '2.25rem',
            width: '2.25rem',
            padding: '0.3125rem'
        },
        ...size === 'large' && {
            height: '2.5rem',
            width: '2.5rem',
            padding: '0.4375rem'
        },
        ...Boolean(outlined) && {
            boxShadow: `${theme.tokens.FuelShadowXs}, rgba(0, 0, 0, 0.05) 0px 1px 0px 0px`,
            border: `1px solid ${theme.tokens.FuelColorBorderDark}`
        },
        '&:hover': {
            color: `${theme.tokens.FuelColorTextPrimary}`
        },
        '&:active': {
            backgroundColor: `${theme.tokens.FuelColorBackgroundActionSecondaryPressed}`
        },
        '&:focus': {
            outline: 'none'
        },
        '&[disabled], &.Mui-disabled': {
            color: `${theme.tokens.FuelColorTextActionSecondary}`,
            backgroundColor: 'transparent',
            opacity: 0.5,
            cursor: 'not-allowed',
            boxShadow: 'none',
            ...Boolean(outlined) && {
                borderColor: `${theme.tokens.FuelColorBorderLight}`,
                boxShadow: 'none'
            }
        },
        '&.Mui-focusVisible': {
            boxShadow: `${theme.tokens.FuelShadowFocused}`
        }
    };
});
export const IconButton = React.forwardRef(({ size = 'medium', ...props }, ref) => (_jsx(StyledButton, { ...props, ref: ref, size: size })));
IconButton.displayName = 'IconButton';
